import { parseIssueNumber } from './issue-number.js';
/** Hard ceiling so a typo like "1-99999" cannot create a flood of issues. */
export const MAX_RANGE_SIZE = 500;
/**
 * Parses the quick-add input: "1-25, 30, 32" or "1–25; 30" or "Annual 1".
 * Both the hyphen and the en dash separate a range, commas and semicolons
 * separate entries. Anything that is not a plain number is taken literally,
 * so "Annual 1" or "1/2" can be added the same way.
 */
export function parseIssueRange(input) {
    const numbers = [];
    const errors = [];
    const seen = new Set();
    const add = (value) => {
        if (seen.has(value))
            return;
        seen.add(value);
        numbers.push(value);
    };
    for (const rawToken of input.split(/[,;\n]/)) {
        const token = rawToken.trim();
        if (!token)
            continue;
        const range = /^(\d+)\s*[-–—]\s*(\d+)$/.exec(token);
        if (!range) {
            add(token);
            continue;
        }
        const start = Number(range[1]);
        const end = Number(range[2]);
        if (start > end) {
            errors.push(`"${token}": Startnummer ist größer als die Endnummer`);
            continue;
        }
        if (end - start + 1 > MAX_RANGE_SIZE) {
            errors.push(`"${token}": mehr als ${MAX_RANGE_SIZE} Ausgaben auf einmal`);
            continue;
        }
        for (let current = start; current <= end; current += 1) {
            add(String(current));
        }
    }
    if (numbers.length > MAX_RANGE_SIZE) {
        errors.push(`Mehr als ${MAX_RANGE_SIZE} Ausgaben auf einmal`);
        return { numbers: numbers.slice(0, MAX_RANGE_SIZE), errors };
    }
    return { numbers, errors };
}
/**
 * Next number of a run: the highest regular issue number plus one. Specials
 * and numberless entries are ignored, so "Annual 1" never drives the count.
 */
export function nextIssueNumber(existing) {
    let highest = 0;
    let found = false;
    for (const number of existing) {
        const parsed = parseIssueNumber(number);
        if (parsed.rank !== 0 || parsed.sort === null)
            continue;
        found = true;
        highest = Math.max(highest, parsed.sort);
    }
    if (!found)
        return '1';
    return String(Math.floor(highest) + 1);
}
/**
 * Numbers of a run that are not present yet: every integer from 1 to the
 * expected total that no issue covers. Specials are ignored.
 */
export function missingIssueNumbers(existing, expectedCount) {
    const owned = new Set();
    for (const number of existing) {
        const parsed = parseIssueNumber(number);
        if (parsed.rank !== 0 || parsed.sort === null)
            continue;
        if (Number.isInteger(parsed.sort))
            owned.add(parsed.sort);
    }
    const missing = [];
    for (let current = 1; current <= expectedCount; current += 1) {
        if (!owned.has(current))
            missing.push(String(current));
    }
    return missing;
}
//# sourceMappingURL=issue-range.js.map